
export const getCDPAltText = ({ year = "", make = "", model = "", variant = "", transmissionType = "", odometerReading = "" } = {}) => {
    // Build car name from available values
    const carNameParts = [year, make, model, variant].filter(Boolean);
    const carName = carNameParts.join(" ");

    // Build additional details
    const details = [];
    if (transmissionType) details.push(transmissionType);
    if (odometerReading) details.push(`${odometerReading} km`);

    // Combine all parts
    const allParts = [carName, ...details].filter(Boolean);
    return allParts.join(", ");
};
